module.exports = __webpack_public_path__ + "static/111-37475fe9c25af4c5b876c76488e89fb2.png";